import React from 'react';
import Header from './Header';
import Footer from './Footer';
import DisclaimerBanner from './DisclaimerBanner';

const Layout: React.FC<{ children: React.ReactNode; showHeader?: boolean }> = ({
  children,
  showHeader = true,
}) => {
  const paddingTop = showHeader
    ? 'calc(5rem + var(--disclaimer-banner-height, 0px))'
    : 'var(--disclaimer-banner-height, 0px)';
  const mainPaddingClass = showHeader ? 'pt-20' : 'pt-10';

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <DisclaimerBanner />
      {showHeader && <Header />}
      <main
        className={`flex-1 ${mainPaddingClass}`}
        style={{ paddingTop }}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
